import * as React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import { RedirectToDefault, ROUTE_PATH } from '../../constants';
import DashboardView from './DashboardView';
import SecurityReadiness from './SecurityReadiness';
import SensorDetailsView from './SensorDetailsView';
import AgentEndpointView from './agent/AgentEndpointView';
import VirtualSensorView, {
  ifVanillaSensorFeatureFlag,
} from '../self-service/virtualsensor/VirtualSensorListView';
import VanillaSensorView from '../self-service/virtualsensor/VanillaSensorListView';

const VanillaSensorComponent = ifVanillaSensorFeatureFlag(
  VanillaSensorView,
  VirtualSensorView,
);

export default class DashboardRouteManager extends React.Component<RouteComponentProps> {
  render() {
    const { match } = this.props;

    return (
      <Switch>
        <Route
          exact
          path={`${match.url}/sensors`}
          component={SensorDetailsView}
        />
        <Route
          exact
          path={ROUTE_PATH.SELF_SERVICE.VIRTUAL}
          component={VanillaSensorComponent}
        />
        <Route
          exact
          path={`${match.url}/coverage-score`}
          component={SecurityReadiness}
        />
        <Route
          exact
          path={`${match.url}/endpoints`}
          component={AgentEndpointView}
        />
        <Route exact path={`${match.url}/`} component={DashboardView} />
        <RedirectToDefault />
      </Switch>
    );
  }
}
